/* import __COLOCATED_TEMPLATE__ from './abs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();